interface AccessibilityTabProps {
  contentWarnings: string | null;
  accessibility: string | null;
}

/** Accessibility tab — brd-frontend.md §6.3, frd.md FR-TAB-04. Content and
 *  Access sub-sections render independently of each other; the parent
 *  `ShowDetailTabs` hides the whole tab when both are absent. */
export function AccessibilityTab({ contentWarnings, accessibility }: AccessibilityTabProps) {
  return (
    <div className="shows-detail-tab-panel">
      <h4>Accessibility</h4>

      {contentWarnings && (
        <div className="shows-detail-accessibility-item">
          <i className="fa-light fa-file-pen" aria-hidden />
          <div>
            <h5>Content</h5>
            <p>{contentWarnings}</p>
          </div>
        </div>
      )}

      {accessibility && (
        <div className="shows-detail-accessibility-item">
          <i className="fa-light fa-wheelchair" aria-hidden />
          <div>
            <h5>Access</h5>
            <p>{accessibility}</p>
          </div>
        </div>
      )}
    </div>
  );
}
